import { render, staticRenderFns } from "./devinfo.vue?vue&type=template&id=c72115c4&"
import script from "./devinfo.vue?vue&type=script&lang=js&"
export * from "./devinfo.vue?vue&type=script&lang=js&"
import style0 from "./devinfo.vue?vue&type=style&index=0&id=c72115c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports